import { apiClient } from "../axios.config";
import type { Response } from "../dto/response/common.response";
import type { getResveCancelListForm, getResveGolfParkSearchRequest, getResveListForm, getResveTimeDetailGolfParkForm, getResveTimeListGolfParkForm } from "../dto/request/resve.request";
import type { ResveCancelDetailResponse, ResveCancelListResponse, ResveDetailResponse, ResveGolfParkSearchResponse, ResveListResponse } from "../dto/response/resve.response";

const model = '/v1/resve';

/**
 * Score Service API
 * @module ScoreResve
 * @description 예약 관련 API
 * @since 1.0.0
 */

/** 예약 목록 조회 */
export async function getResveList(form: getResveListForm): Promise<Response<ResveListResponse>> {
  const { data } = await apiClient.get(`${model}/me/list`, { params: form });
  return data;
}

/** 예약 취소 목록 조회 */
export async function getResveCancelList(form: getResveCancelListForm): Promise<Response<ResveCancelListResponse>> {
  const { data } = await apiClient.get(`${model}/me/cancel-list`, { params: form });
  return data;
}

/** 예약 상세 조회 */
export async function getResveDetail(id: string | number): Promise<Response<ResveDetailResponse>> {
  const {data} = await apiClient.get(`${model}/me/${id}/detail`);
  return data;
}

/** 예약 취소 상세 조회 */
export async function getResveCancelDetail(id: string | number): Promise<Response<ResveCancelDetailResponse>> {
  const {data} = await apiClient.get(`${model}/me/${id}/cancel-detail`);
  return data;
}

/** 예약 골프장 검색 */
export async function getResveGolfParkSearch(form: getResveGolfParkSearchRequest): Promise<Response<{ golfParkList: ResveGolfParkSearchResponse[] }>> {
  const { data } = await apiClient.get(`${model}/${form.date}/golf-park/list`, { params: form });
  return data;
}

/** 예약 타임 목록 조회 */
export async function getResveTimeGolfPark(form: getResveTimeListGolfParkForm): Promise<Response<ResveListResponse>> {
  const { data } = await apiClient.get(`${model}/${form.date}/time-list`, { params: form });
  return data;
}

/** 예약 타임 상세 조회 */
export async function getResveTimeDetailGolfPark(form: getResveTimeDetailGolfParkForm): Promise<Response<ResveDetailResponse>> {
  const { data } = await apiClient.get(`${model}/${form.date}/time/${form.resveSeq}/detail`, { params: form });
  return data;
}